import { defineStore } from "pinia";
import { FetchState, MessageCenterMessage, MessageCenterState } from "@/shared/types";
import * as advisorService from "@/shared/api/advisor3Service";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";

export const initialState: MessageCenterState = {
    messagesFetchState: FetchState.Uninitialized,
    messageFetchState: FetchState.Uninitialized,
    messages: [],
    selectedMessage: null
};

export const useMessageCenterStore = defineStore("messageCenter", {
    state: (): MessageCenterState => (_.cloneDeep(initialState)),
    getters: {
        messagesAreLoaded: state => state.messagesFetchState === FetchState.Loaded
    },
    actions: {
        setMessagesFetchState (fetchState: FetchState) {
            this.messagesFetchState = fetchState;
        },
        setMessageFetchState (fetchState: FetchState) {
            this.messageFetchState = fetchState;
        },
        setMessages (
            messages: MessageCenterMessage[]) {
            this.setMessagesFetchState(FetchState.Loaded);
            this.messages = messages;
        },
        setMessage (
            message: MessageCenterMessage) {
            this.setMessageFetchState(FetchState.Loaded);
            this.selectedMessage = message;
        },
        getMessages (): Promise<any> {
            this.setMessagesFetchState(FetchState.Loading);

            return advisorService.getMessages()
                .then(response => this.setMessages(response.data.items))
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        getSelectedMessage ( id: string): Promise<any> {
            this.setMessageFetchState(FetchState.Loading);

            return advisorService.getMessage(id)
                .then(response => this.setMessage(response.data))
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        }
    }
});